import {Component, OnInit} from '@angular/core';
import {Observable} from "rxjs";
import {ApiService, ChatbotDef} from "../../../services/api.service";
import {DeleteButtonComponent} from "../../../core/delete-button/delete-button.component";
import {ManageButtonComponent} from "../../../core/manage-button/manage-button.component";
import {PreviewButtonComponent} from "../../../core/preview-button/preview-button.component";
import {QuickDashboardComponent} from "../../../core/quick-dashboard/quick-dashboard.component";
import {JsonPipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {MatButtonModule} from "@angular/material/button";
import {RouterLink} from "@angular/router";
import {MatIconModule} from "@angular/material/icon";
import {TenantIdTagComponent} from "../../tenants/tenant-id-tag/tenant-id-tag.component";

@Component({
  selector: 'app-chatbots-list',
  standalone: true,
  imports: [
    DeleteButtonComponent,
    ManageButtonComponent,
    PreviewButtonComponent,
    QuickDashboardComponent,
    NgIf,
    NgForOf,
    NgClass,
    MatButtonModule,
    RouterLink,
    MatIconModule,
    TenantIdTagComponent,
    JsonPipe
  ],
  templateUrl: './chatbots-list.component.html'
})
export class ChatbotsListComponent implements OnInit {

  loader?: Observable<ChatbotDef[]>

  constructor(
    readonly api: ApiService,
  ) {}

  ngOnInit(): void {
    this.loader = this.api.getChatbots()
  }

  isRagVariableDisabled(ragKey: string, bot: ChatbotDef) {
    if (bot.settings && bot.settings.ragSearch && ragKey in bot.settings.ragSearch) {
      return bot.settings.ragSearch[ragKey].disabled
    }
    return false
  }

  protected readonly Object = Object
}
